import * as Sentry from "@sentry/browser";

// オプション ： https://docs.sentry.io/platforms/javascript/configuration/options/#release
Sentry.init({
    dsn: process.env.MIX_SENTRY_LARAVEL_DSN,
    environment: process.env.NODE_ENV,
        integrations: [
            Sentry.captureConsoleIntegration(
                {
                    levels: ['error', 'warn'],
                }
            )
        ],
    // ログに記録されるすべてのメッセージにスタックトレースを追加する
    attachStacktrace: true,
    // セッショントラッキングを有効にする
    autoSessionTracking: true,
    // プランの制限により、セッションリプレイは無効にしている
    tracesSampleRate: 0,
    // セッションリプレイの設定
    // プランの制限により、セッションリプレイは無効にしている
    // ユーザー操作を記録するセッションリプレイの設定
    replaysSessionSampleRate: 0,
    // エラーが発生した時のセッションリプレイの設定
    replaysOnErrorSampleRate: 0,

    allowUrls: [
        // /public/js/ディレクトリ内のスクリプトのみを対象とする
        /https?:\/\/lmsg\.jp\/js\//, // prod環境
        /https?:\/\/innovation\.test\-lmsg\.net\/js\//, // stg環境
        /https?:\/\/lmsg\.development\/js\//, // local環境
    ],
});

Sentry.setTag('display', 'lmsg');
Sentry.setTag('role', 'user');
